import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { FounderProof } from './components/FounderProof';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { SystemOverview } from './components/SystemOverview';
import { Stages } from './components/Stages';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { Upsell } from './components/Upsell';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-white font-sans selection:bg-gold-500 selection:text-black" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <FounderProof data-id="element-3" />
      <PainPoints data-id="element-4" />
      <TargetAudience data-id="element-5" />
      <SystemOverview data-id="element-6" />
      <Stages data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Comparison data-id="element-9" />
      <Pricing data-id="element-10" />
      <Upsell data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}